<template>
  <section class="hero container">
    <div class="hero-inner">
      <div class="hero-media">
        <img :src="featureGraphic" alt="Noun Rush feature graphic" />
      </div>
      <div class="hero-copy">
        <h1>Noun Rush</h1>
        <p class="lead">The ultimate category word challenge — race the clock and win!</p>

        <p class="cta">
          <a :href="playUrl" target="_blank" rel="noopener">
            <img :src="playBadge" alt="Get it on Google Play" />
          </a>
        </p>

        <ul class="features">
          <li>Standard Mode — Boy, Girl, Animal, Place, Thing</li>
          <li>Blitz Mode — fast rounds and five letters</li>
          <li>Hangman & Falling Words — classic and new twists</li>
          <li>XP, Avatars & Achievements — progress & rewards</li>
          <li>Offline play + Google Play Saved Games (optional sync)</li>
        </ul>
      </div>
    </div>
  </section>

  <section class="showcase container">
    <h2>Gameplay & Features</h2>
    <div class="grid">
      <article>
        <img :src="loadingImg" alt="Gameplay screenshot" />
        <h3>Quick Matches</h3>
        <p>Fast, addictive rounds designed to test your vocabulary and reflexes.</p>
      </article>
      <article>
        <img :src="bgImg" alt="Background art" />
        <h3>Beautiful UI</h3>
        <p>Clean, colorful interface tuned for mobile play.</p>
      </article>
      <article>
        <img :src="featureGraphic" alt="Feature graphic" />
        <h3>Multiple Modes</h3>
        <p>From classic category rounds to unique twists and challenges.</p>
      </article>
    </div>
  </section>
</template>

<script setup>
import featureGraphic from '@/assets/noun rush feature graphic 1024 x 500.png'
import loadingImg from '@/assets/noun rush loading.png'
import bgImg from '@/assets/nouin rush background 1.png'
import playBadge from '@/assets/play-badge.svg'

const playUrl = 'https://play.google.com/store/apps/details?id=com.southsidegamez.WordRouletteOnline'
</script>

<style scoped>
.hero{padding:28px 0}
.hero-inner{display:flex;gap:24px;align-items:center;flex-wrap:wrap}
.hero-media img{max-width:520px;width:100%;height:auto;border-radius:12px;display:block}
.hero-copy{flex:1;min-width:260px}
.hero-copy h1{font-size:clamp(1.5rem,3.5vw,2.2rem);margin:0 0 8px}
.lead{color:var(--muted,#9aa4b2);font-size:clamp(1rem,1.6vw,1.125rem);margin-bottom:12px}
.cta img{height:clamp(40px,6vw,56px)}
.features{list-style:none;padding:0;margin:12px 0;color:var(--muted,#9aa4b2)}
.showcase{padding:20px 0}
.grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:12px}
.grid article{background:rgba(255,255,255,0.03);padding:12px;border-radius:10px;text-align:center}
.grid img{width:100%;height:140px;object-fit:cover;border-radius:8px}

@media (max-width:1024px){
  .hero-inner{gap:18px}
}

@media (max-width:760px){
  .hero-inner{flex-direction:column}
  .hero-media img{max-width:100%}
}
</style>
